<div class="listing-container">
  <div class="header-section">
    <button class="btn-create" (click)="onCreate()">
      Create Survey
    </button>
  </div>

  <div class="content-section">
    <h2 class="page-title">Survey Questions</h2>

    <div class="filter-section">
      <div class="search-box">
        <input 
          type="text" 
          [(ngModel)]="searchText"
          (input)="onSearch()"
          placeholder="Search Survey"
          class="search-input"
        />
        <button class="search-btn" (click)="onSearch()">
          <i class="search-icon">🔍</i>
        </button>
      </div>

      <!-- <div class="filter-box">
        <label class="filter-label">Status</label>
        <select 
          [(ngModel)]="selectedStatus"
          (change)="onStatusChange()"
          class="filter-select"
        >
          <option *ngFor="let status of statusOptions" [value]="status">
            {{ status }}
          </option>
        </select>
      </div> -->
    </div>

    <div class="table-container" *ngIf="!isLoading">
      <table class="data-table">
        <thead>
          <tr>
            <th>Survey Number</th>
            <th>Survey Title</th>
            <!-- <th>Description</th>
            <th>Created By</th>
            <th>Status</th>
            <th>Assigned</th>
            <th>Completed</th>
            <th>Progress</th>
            <th>Created Date</th> -->
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            *ngFor="let survey of filteredSurveys"
            class="clickable-row"
            (click)="onView(survey.survey_id)"
          >
            <td>{{ survey.survey_number }}</td>
            <td>{{ survey.survey_title }}</td>

            <td (click)="$event.stopPropagation()">
              <div class="action-buttons">

                <!-- ❌ Removed View Button -->

                <button 
                  class="btn-action btn-edit" 
                  (click)="onEdit(survey.survey_id)"
                  title="Edit"
                >
                  ✏️ Edit
                </button>

                <button 
                    class="btn-action btn-delete" 
                    (click)="onDelete(survey.survey_id, survey.survey_title)"
                    title="Delete"
                  >
                    🗑️ Delete
                </button>

              </div>
            </td>
          </tr>

          <tr *ngIf="filteredSurveys.length === 0">
            <td colspan="10" class="no-data">
              No surveys found
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    <div class="loading-container" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading surveys...</p>
    </div>
  </div>
</div>